function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.7314 24.0477C13.5774 23.3252 13.4724 22.5935 13.417 21.8572C13.5074 21.0143 13.8567 20.2185 14.4185 19.5761C14.9802 18.9337 15.7275 18.4753 16.5608 18.262C17.5764 18.0001 18.5922 17.762 19.5595 17.5715C19.5595 18.3811 19.7772 19.2144 19.8739 19.9525C19.9706 20.6906 19.9947 21.3811 20.0431 22.1192",
  stroke: "#CDCDCD",
  strokeWidth: 1.5,
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M32.7877 24.0238C32.7877 26.2619 32.7877 28.3571 32.7877 30.2619C32.7877 28.3571 32.7877 26.2619 32.7877 24.0238ZM32.7877 24.0238C32.7877 21.7857 33.1262 19.5238 33.4164 17.5476C33.1262 19.4523 32.9086 21.6904 32.7877 24.0238ZM26.3066 31H26.5001C27.8365 31.0173 29.17 31.1287 30.4903 31.3333C30.7965 31.3846 31.1103 31.3707 31.4107 31.2927C31.711 31.2147 31.9908 31.0743 32.2315 30.8809C32.4596 30.716 32.6493 30.5049 32.7877 30.2619L33.4648 30.4523C34.0449 30.6314 34.6582 30.6816 35.2603 30.5992C35.8625 30.5169 36.4386 30.3041 36.9472 29.9761C37.1931 29.8284 37.4204 29.6526 37.6243 29.4523V29.4523L38.0838 29.6904C38.6256 29.9642 39.2251 30.1089 39.8341 30.1131C40.4431 30.1172 41.0446 29.9807 41.5903 29.7144C42.1359 29.4481 42.6106 29.0595 42.976 28.5798C43.3414 28.1001 43.5873 27.5427 43.6942 26.9523C43.8492 26.1453 43.7352 25.3106 43.3692 24.5727C43.0031 23.8347 42.4045 23.2329 41.6628 22.8571L39.5347 21.8333C39.4493 20.9923 39.1047 20.1971 38.5471 19.5544C37.9895 18.9118 37.2456 18.4525 36.4152 18.2381C35.3753 17.9762 34.3837 17.7381 33.4164 17.5476C33.0971 16.9415 32.629 16.4236 32.0546 16.041C31.4802 15.6584 30.8178 15.4233 30.1276 15.3571C28.8217 15.238 27.7092 15.1904 26.4759 15.1904C25.2426 15.1904 24.0576 15.1904 22.8001 15.3571C21.8838 15.4676 21.032 15.8786 20.3818 16.5238C20.0841 16.8285 19.8317 17.1732 19.6321 17.5476C19.6321 18.3571 19.8498 19.1904 19.9465 19.9285C20.0433 20.6666 20.0674 21.3571 20.1158 22.0952M38.9543 25.5952C38.6147 26.9133 38.17 28.2031 37.6243 29.4523C38.17 28.2031 38.6147 26.9133 38.9543 25.5952C39.2515 24.358 39.4536 23.1004 39.5589 21.8333C39.4536 23.1004 39.2515 24.358 38.9543 25.5952V25.5952Z",
  stroke: "#CDCDCD",
  strokeWidth: 1.5,
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M13.7314 24.0477C13.5775 23.3252 13.4725 22.5934 13.4171 21.8572L11.3131 22.8572C10.9554 23.0562 10.6226 23.296 10.3216 23.5715C9.87461 24.0142 9.54572 24.559 9.36429 25.1572C9.18286 25.7554 9.15454 26.3884 9.28178 27C9.37641 27.548 9.59792 28.0672 9.92923 28.5172C10.2605 28.9673 10.6927 29.3362 11.1922 29.5953",
  stroke: "#CDCDCD",
  strokeWidth: 1.5,
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M19.1 22.1191C19.1 25.143 19.1 28.0239 18.9549 30.7144L17.5039 31.143C15.4522 31.765 13.2395 31.6209 11.2889 30.7382",
  stroke: "#CDCDCD",
  strokeWidth: 1.5,
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M19.1 22.1191C19.1 25.143 19.1001 28.0239 18.955 30.7144C19.2702 31.2218 19.6709 31.6727 20.1399 32.0477C20.6644 32.4521 21.2681 32.7453 21.9131 32.9092C22.5581 33.0731 23.2305 33.104 23.8882 33.0001C24.517 33.0001 25.1216 32.8096 25.7262 32.7382",
  stroke: "#CDCDCD",
  strokeWidth: 1.5,
  strokeLinejoin: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M24.2509 34.9287L30.5869 41.143",
  stroke: "#CDCDCD",
  strokeWidth: 1.5,
  strokeLinejoin: "round"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M18.8097 37.1191C23.0168 37.1191 26.4274 33.7613 26.4274 29.6191C26.4274 25.477 23.0168 22.1191 18.8097 22.1191C14.6026 22.1191 11.1921 25.477 11.1921 29.6191C11.1921 33.7613 14.6026 37.1191 18.8097 37.1191Z",
  stroke: "#CDCDCD",
  strokeWidth: 1.5,
  strokeLinejoin: "round"
});

var SvgItemAnalytic = function SvgItemAnalytic(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgItemAnalytic, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/item-analytic.0d756421.svg";
export { ForwardRef as ReactComponent };